import { render, staticRenderFns } from "./7.vue?vue&type=template&id=80d5182a&scoped=true&"
import script from "./7.vue?vue&type=script&lang=js&"
export * from "./7.vue?vue&type=script&lang=js&"
import style0 from "./7.vue?vue&type=style&index=0&id=80d5182a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d5182a",
  null
  
)

export default component.exports